export const CycleInstanceSteps = {
    SELECT_REVIEWEE: 'SelectReviewee',
    ASSIGN_REVIEWER: 'AssignReviewer',
    SELECT_TEMPLATE: 'SelectTemplate',
    QUESTIONNAIRE_CREATION: 'QuestionnaireCreation',
    SCHEDULE_CREATION: 'ScheduleCreation',
} as const;

export type CycleInstanceSteps = (typeof CycleInstanceSteps)[keyof typeof CycleInstanceSteps];
